require('./bootstrap');
require('./fontawesome');

document.addEventListener("DOMContentLoaded", function() {
    // Confirm employee delete
    document.querySelectorAll('.delete-employee').forEach(function (el) {
        el.addEventListener('click', function () {
            let name = el.getAttribute('data-name');

            if (confirm(`Are you sure you want to delete employee ${name}?`)) {
                el.parentElement.submit();
            }
        });
    });
});
